"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fillAnimation = void 0;
const defaults = {
    duration: 'unset',
    delay: 'unset',
    timingFunction: 'unset',
    iterationCount: 'unset',
    direction: 'unset',
    fillMode: 'unset',
    playState: 'unset',
};
const fillAnimation = (patch) => ({ ...defaults, ...patch });
exports.fillAnimation = fillAnimation;
